import React from "react";
import { Link } from "gatsby";
import { Div, Image, Text } from "atomize";

import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import PrimaryButton from "../common/PrimaryButton";

const BlogCtaFooter = ({ blogCtaFooter }) => (
  <Div
    className="blog-cta-footer"
    textAlign="center"
    maxW="45rem"
    m={{ xs: "5.5rem auto 0", md: "7.3rem auto 0" }}
    p={{ b: { xs: "3rem", md: "1rem" } }}
  >
    <ImageLink link="/">
      <Image src="/images/trend-logo.svg" w="auto" h="1rem" />
    </ImageLink>
    <Text
      className="blog-cta-title"
      textWeight="800"
      m={{ t: { xs: "1.25rem", md: "1.9rem" } }}
    >
      {blogCtaFooter.title}
    </Text>
    <Div m={{ t: "2.25rem" }} d="flex" align="center" justify="center">
      <Div>
        <PrimaryButton
          className="blog-cta-btn"
          bg="primary"
          hoverBg="primary"
          textColor="black"
          textTransform="none"
          border="none"
          onClick={() => (window.location.href = blogCtaFooter.btnPrimary.link)}
        >
          {blogCtaFooter.btnPrimary.text}
        </PrimaryButton>
      </Div>
      <Div m={{ l: "1rem" }}>
        <PrimaryButton
          className="blog-cta-btn"
          bg="white"
          hoverBg="white"
          textColor="black"
          textTransform="none"
          border="none"
          onClick={() =>
            (window.location.href = blogCtaFooter.btnSecondary.link)
          }
        >
          {blogCtaFooter.btnSecondary.text}
        </PrimaryButton>
      </Div>
    </Div>
  </Div>
);

export default BlogCtaFooter;
